export default {
  options: {
    doneBtnText: 'OK',
    closeBtnText: 'OK',
    nextBtnText: 'OK',
    prevBtnText: 'Previous'
  },
  layout: {
    languageSwitcher: {
      title: 'Switch Language',
      description: 'You can click here to switch the system language'
    },
    backToOldBtn: {
      title: 'Back to old',
      description: 'You can click here to switch back to the old version of OKR'
    },
    weeklyBtn: {
      title: '周报模式',
      description: '点击后进入周报模式，可随时切换回普通模式'
    },
    myTeamWeeklyBtn: {
      title: '我的团队周报',
      description: '点击后进入我的团队周报'
    },
    myTeamOkr: {
      title: '团队OKR',
      description: '点击后查看同部门人员列表'
    }
  },
  okr: {
    create: {
      howToCreate: 'How to create OKR, click to learn',
      primary: 'Create and build personal OKRs, formulate annual or quarterly work goals and key results',
      remark: 'Note: After the OKR is created, you need to click Publish to take effect',
      remark1: 'Recommend to create up to 3 Objectives to make the goals more focused',
      image: require('@/assets/images/guide/how-to-create_en.gif')
    },
    align: {
      self: {
        objective: {
          title: 'Align & Invite to Align',
          description: 'You can click here to align the OKR of others or invite others to align your OKR',
          doc: {
            text: 'How to Align',
            url: 'https://funplus.yuque.com/docs/share/50a64308-d30d-47fe-9041-46a4842f397b'
          },
          image: require('@/assets/images/guide/how-to-align_en.gif')
        }
      },
      other: {
        title: 'Align to Other',
        description: 'When viewing the OKR of others, you can directly align the  O or KR that others invited you to align，Or take the initiative to align the O or KR that did not invite you to align'
      }
    }
  },
  unpublishedWarning: {
    title: 'Unpublished',
    description: 'There is draft to publish，please click to publish'
  }
}
